export default __webpack_public_path__ + "static/guarantee-min-a66e12ca68825b57c607916488d6d5cd.jpeg";